"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatDate = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var monthShort = [
    '',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
var monthLong = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var formatter = function (year, month, day, format) {
    if (format === 'short') {
        // 01/01/2020
        return "" + (day < 10 ? '0' : '') + day + "/" + (month < 10 ? '0' : '') + month + "/" + year;
    }
    else if (format === 'medium') {
        // 1 Jan 2020
        return day + " " + monthShort[month] + " " + year;
    }
    else if (format === 'long') {
        // 1 January 2020
        return day + " " + monthLong[month] + " " + year;
    }
    else if (format === 'screenreader') {
        // 1st January 2020
        var ordinal = function (dayString) {
            switch (dayString) {
                case 1:
                case 21:
                case 31:
                    return 'st';
                case 2:
                case 22:
                    return 'nd';
                case 3:
                case 23:
                    return 'rd';
                default:
                    return 'th';
            }
        };
        return "" + day + ordinal(day) + " " + monthLong[month] + " " + year;
    }
};
var FormatDate = function (props) {
    if (!props.timestamp) {
        return null;
    }
    var attributes = {
        className: 'honeycomb-date',
    };
    var year = 0;
    var month = 0;
    var day = 0;
    if (props.useLocalTimezone) {
        // Create a date object to convert to the user's timezone
        var date = new Date(props.timestamp);
        year = date.getFullYear();
        month = date.getMonth() + 1;
        day = date.getDate();
        attributes['data-offset'] = date.getTimezoneOffset();
    }
    else {
        // Create date in the timezone provided by the server
        var matches = props.timestamp.match(/^(\d{4,4})-(\d{2,2})-(\d{2,2})/);
        if (matches === null) {
            return null;
        }
        year = parseInt(matches[1], 10);
        month = parseInt(matches[2], 10);
        day = parseInt(matches[3], 10);
    }
    return (React.createElement("span", __assign({}, attributes),
        React.createElement("span", { "aria-hidden": true }, formatter(year, month, day, props.format)),
        React.createElement("span", { className: "sr-only" }, formatter(year, month, day, 'screenreader'))));
};
exports.FormatDate = FormatDate;
exports.FormatDate.defaultProps = {
    format: 'short',
    useLocalTimezone: false,
};
exports.FormatDate.propTypes = {
    format: PropTypes.oneOf(['short', 'medium', 'long', 'screenreader']),
    timestamp: PropTypes.string.isRequired,
    timestampFormat: function (props) {
        if (props.timestamp && !props.timestamp.match(/^\d{4,4}-\d{2,2}-\d{2,2}/)) {
            return new Error('The timestamp format should be yyyy-MM-dd');
        }
        return;
    },
    useLocalTimezone: PropTypes.bool,
};
